import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import CustomerInfoPanel from './Components/Home';
import store from './Store/Store';
import ErrorBoundary from './ErrorBoundary';

interface propsData {
  contextData?: any;
  conversationSummary?: any;
  conversationSentiments?: {
    [contactId: string]: string;
  };
  conversationSentimentLoading: {
    [contactId: string]: boolean;
  };
  agentPath: Array<{ DisplayName: string; ContactId: string; ParticipantId: string }> | string;
  feedback: any;
  sentimentEnabled: boolean;
  trendLineData: any;
  enableSummary: boolean;
  callBackEvent: (event: string, eventData: any) => void;
  darkMode: boolean;
  CIP: boolean;
  language: string;
  urls: {
    HENDRIX_DOMAIN: string;
    CM_DOMAIN: string;
    CIP_DOMAIN: string;
    CCP_API_END_POINT: string;
    RTS_PROCESSOR_ENDPOINT: string;
  };
}

const App = ({
  contextData,
  conversationSummary,
  conversationSentiments,
  conversationSentimentLoading,
  agentPath,
  sentimentEnabled,
  trendLineData,
  enableSummary,
  darkMode,
  CIP,
  language,
  urls,
  callBackEvent,
  feedback,
}: propsData) => {
  return (
    <ReduxProvider store={store}>
      <ErrorBoundary>
        <CustomerInfoPanel
          contextData={contextData}
          conversationSummary={conversationSummary}
          conversationSentiments={conversationSentiments}
          conversationSentimentsLoading={conversationSentimentLoading}
          sentimentEnabled={sentimentEnabled}
          trendLineData={trendLineData}
          feedback={feedback}
          agentPath={agentPath}
          enableSummary={enableSummary}
          darkMode={darkMode}
          CIP={CIP}
          language={language}
          urls={urls}
          callBackEvent={callBackEvent}
        />
      </ErrorBoundary>
    </ReduxProvider>
  );
};

export default App;
